export var HEADER_NAVIGATION_LINK_CLASS_PREFIX = 'HeaderNavigationLink';
export var headerNavigationLinkRoot = 'HeaderNavigationLinkRoot';